export const GameSessionStatus = {
	"pending": "Pending",
	"playing": "Playing",
	"finished": "Finished",
	"closed": "Closed",
} as const

export type GameSessionStatusType = "pending" | "playing" | "finished" | "closed"

export const TransactionType = {
	"lab-consulting": "solution consulting",
	"marketing-campaign": "marketing campaign",
	"marketing-training-broad": "marketing training broad",
	"marketing-training-deep": "marketing training deep",
	"hdma": "HDMA",
	"operational-cost": "operational costs",
	"project-uptime-bonus": "project uptime bonus",
	"project-won": "project won",
} as const

export type TransactionTypeType = "lab-consulting" | "marketing-campaign" | "marketing-training-broad" | "marketing-training-deep" | "hdma" | "operational-cost" | "project-uptime-bonus" | "project-won"

export const GameSessionRoundStatus = {
	"active": "Active",
	"processing": "Processing",
	"processed": "Processed",
	"paused": "Paused",
} as const

export type GameSessionRoundStatusType = "active" | "processing" | "processed" | "paused"

export const GameSessionFlow = {
	"low": "Low",
	"medium": "Medium",
	"high": "High",
} as const

export type GameSessionFlowType = "low" | "medium" | "high"

export const SystemTaskStatus = {
	"pending": "pending",
	"processing": "processing",
	"completed": "completed",
	"failed": "failed",
} as const

export type SystemTaskStatusType = "pending" | "processing" | "completed" | "failed"

export const ProjectStatus = {
	"pending": "Pending",
	"lost": "Lost",
	"won": "Won",
	"active": "Active",
	"down": "Down",
	"finished": "Finished",
} as const

export type ProjectStatusType = "pending" | "lost" | "won" | "active" | "down" | "finished"